export enum DomainType {
    AGENT = 'Agent',
    SIGNATURE = 'Signature',
    SIGNATURE_RULE = 'Signature Rule',
    BANK_ACCOUNT = 'Bank Account',
    COOBLIGATION = 'Coobligation',
    INSTITUTION = 'Institution',
    PARTICIPATION = 'Participation',
    REGISTRATION_STATUS = 'Registration Status',
    COUNTRY = 'Country',
    ISSUING_ORGAN = 'Issuing Organ',
    CIVIL_STATUS = 'Civil Status',
    QUALIFICATION = 'Qualification',
    CVM_PROFILE = 'CVM Profile',
    PROFILE_CLASS = 'Profile class',
    PERSON = 'Person'
}
